/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

export default class Api {
  baseURL = '//{ENV}purchaseordersapi.eved.com'
  // baseURL = '//localhost:58205'

  ComputeLineItemTotals              = () => `${this.baseURL}/api/LineItem/ComputeTotals`
  SavingsComputeLineItemTotals       = () => `${this.baseURL}/api/SavingsLineItem/ComputeTotals`
  ComputeFeeTotals                   = () => `${this.baseURL}/api/LineItem/ComputeFeeTotals`
  PurchaseOrderComputeTotals         = () => `${this.baseURL}/api/PurchaseOrderBuyer/ComputeTotals`
  SavingsPurchaseOrderComputeTotals  = () => `${this.baseURL}/api/SavingsPurchaseOrderBuyer/ComputeTotals`
  GetPurchaseOrderDetails            = () => `${this.baseURL}/api/PurchaseOrderBuyer/Get`
  GetSavingsDetails                  = () => `${this.baseURL}/api/SavingsPurchaseOrderBuyer/Get`
  AddFeeOrDiscountItemGet            = () => `${this.baseURL}/api/AddFeeOrDiscountItem`
  SavePurchaseOrder                  = () => `${this.baseURL}/api/PurchaseOrderBuyer/Save`
  SaveSavings                        = () => `${this.baseURL}/api/SavingsPurchaseOrderBuyer/Save`
  SendPurchaseOrder                  = () => `${this.baseURL}/api/PurchaseOrderBuyer/SendToSupplier`
  SendSavings                        = () => `${this.baseURL}/api/SavingsPurchaseOrderBuyer/SendToSupplier`
  DropDownsListForItem               = () => '/InvoiceToPay/GetItemsCategoriesAndBuAndCc'
  GetCostCentersBusinessUnits        = () => '/InvoiceToPay/GetCostCentersBusinessUnits'
  GetSupplierTaxes                   = () => `${this.baseURL}/api/Supplier/GetTaxes`
  GetSupplierFees                    = () => `${this.baseURL}/api/Supplier/GetFees`
  GetInvoiceTotalAmount              = () => `/InvoiceToPay/GetInvoiceTotalAmount`
  InitUploadInvoice                  = () => `/InvoiceToPay/InitUploadInvoice`
  GetOverBudgetWarningData           = () => `/InvoiceToPay/GetOverBudgetWarningData`
  GetComments                        = () => `/Common/GetInvoiceCommentsJSON`
  SaveComments                       = () => `/Common/SaveInvoiceComment`
  GetPurchaseOrderItems              = () => '/InvoiceToPay/GetPurchaseOrderItems'
  GetAllocations                     = () => '/InvoiceToPay/GetAllocations'
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/api.js